import * as z from "zod";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";

export const setBranchModelPreference = mutator({
  schema: z.object({
    branchId: z.string(),
    aiProviderId: z.string().nullable(),
  }),
  resolve: {
    branch: { kind: "branch", from: "branchId" },
  },
  permissions: [
    {
      permission: "space:write",
      scopeId: ({ args }) => args.branch.workflow.spaceId,
    },
  ],
  fn: async ({ tx, ctx, args: { branch, aiProviderId } }) => {
    const { userId } = ctx;
    if (aiProviderId === null) {
      const existing = await tx.run(
        zql.branchModelPreferences
          .where("userId", userId)
          .where("branchId", branch.id)
          .one()
      );
      if (existing) {
        await tx.mutate.branchModelPreferences.delete({
          userId,
          branchId: branch.id,
        });
      }
      return;
    }
    await tx.mutate.branchModelPreferences.upsert({
      userId,
      branchId: branch.id,
      aiProviderId,
      tenantId: ctx.tenantId,
    });
  },
});
